import { render } from "./default.vue?vue&type=template&id=4c652488&scoped=true&ts=true"
import script from "./default.vue?vue&type=script&lang=ts&config=true"
export * from "./default.vue?vue&type=script&lang=ts&config=true"

import "./default.vue?vue&type=style&index=0&id=4c652488&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c652488"]])

export default __exports__